export default "__VITE_ASSET__DrSe_3dR__"